import { BahasaResponse } from "../../../../models/Bahasa";
import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";

export async function bahasa(BAHASA_ID: number): Promise<BahasaResponse> {
  const res = await ApiClient.get(`/Bahasa?BAHASA_ID=${BAHASA_ID}`);
  return res.data[0];
}

export const useFetchBahasa = mutationWrapper(bahasa);
